<template>
  <v-container fluid>
<!--    <v-row class="justify-center">-->
<!--      <h2 class="font-weight-thin">Sorry, no Poll assigned to you, check later</h2>-->
<!--    </v-row>-->
    <v-row class="">
      <v-col cols="12">
        Running Poll #123
      </v-col>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6">
                  <p>Voter Phone Number: <span class="font-weight-bold">0700 000 000</span></p>
                </v-col>
                <v-col cols="12" md="6">
                  <p>Voter Name: <span class="font-weight-bold">Cool guy</span></p>
                </v-col>
                <v-col cols="12" md="6">
                  <p>ID number: <span class="font-weight-bold">11144777</span></p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <p>Survey Questions</p>
                    </v-col>
                    <v-col cols="12" md="12">
                      <p>Who is your fav governor:</p>
                    </v-col>
                    <v-col cols="12" md="6">
                      <p>1.A1</p>
                      <p>2.A2:</p>
                    </v-col>
                    <v-col cols="12" md="6">
                      <p>3.A3:</p>
                      <p>4.A4:</p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <!--        <v-text-field outlined dense label="Answer"/>-->
              <v-combobox outlined dense label="Answer"/>
              <v-btn @click="" class="primary">Next Question</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Dashboard"
}
</script>

<style scoped>

</style>